import {
  getAnalytics,
  initializeAnalytics,
  isSupported,
  logEvent,
} from "firebase/analytics";
import { app, firebaseAppEnv, firebaseMeasurementId } from "./firebase";

const isProductionAnalyticsEnabled =
  process.env.NODE_ENV === "production" &&
  firebaseAppEnv === "prod" &&
  Boolean(firebaseMeasurementId);

let analyticsPromise = null;

const getClientAnalytics = () => {
  if (!isProductionAnalyticsEnabled || typeof window === "undefined") {
    return Promise.resolve(null);
  }

  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => {
        if (!supported) {
          return null;
        }

        try {
          return initializeAnalytics(app, {
            config: {
              send_page_view: false,
            },
          });
        } catch (error) {
          return getAnalytics(app);
        }
      })
      .catch(() => null);
  }

  return analyticsPromise;
};

export const trackEvent = async (eventName, params = {}) => {
  try {
    const analytics = await getClientAnalytics();
    if (!analytics) {
      return;
    }

    logEvent(analytics, eventName, params);
  } catch (error) {
    // Analytics must never block or break care logging/auth flows.
  }
};

export const trackEventOnce = (storageKey, eventName, params = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  const normalizedKey = `lifelog:analytics:${storageKey}`;
  if (window.localStorage.getItem(normalizedKey) === "1") {
    return;
  }

  window.localStorage.setItem(normalizedKey, "1");
  trackEvent(eventName, params);
};

export const trackPageView = ({ path, title }) => {
  if (!path) {
    return;
  }

  const pageLocation =
    typeof window === "undefined"
      ? path
      : `${window.location.origin}${path}`;

  trackEvent("page_view", {
    page_path: path,
    page_location: pageLocation,
    page_title: title || "Lifelog",
  });
};
